export default __webpack_public_path__ + "static/media/book3.a96950df.png";